module.exports = __webpack_public_path__ + "static/img/pexels--rahulshah--1253811.2b040f9.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/pexels--rahulshah--1253811.webp
// module id = 0fHD
// module chunks = 0